<template>
    <v-container class="">
        <v-card class="" id="uploadCenter">
            <v-card-text>
                <v-container style="background-color: #dc0202;" class="accent-4">
                    <v-row>
                        <v-col cols="4" class="white--text subtitle-2">
                            <v-text-field
                                    class="mt-7"
                                    dense
                                    solo
                                    v-model="playlist.name"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="white--text subtitle-2">
                            <span class="font-weight-bold" v-if="playlist.channel !== 20 && !isGlobal">
                                <v-checkbox dark class="pt-6 pl-4" v-model="playlist.channel" label="Kanal" @change="onChangeChannel"></v-checkbox>
                            </span>
                            <span class="font-weight-bold" v-if="playlist.channel === 20">
                                <v-checkbox dark class="pt-6 pl-4" readonly v-model="playlist.channel" label="Veranstalter Kanal"></v-checkbox>
                            </span>
                        </v-col>
                        <v-col cols="2" class="white--text subtitle-2">
                            <v-text-field
                                    v-if="playlist.channel === 20"
                                    class="mt-7"
                                    dense
                                    dark
                                    label="Maximal Länge in Sekunden"
                                    v-model="playlist.maxLength"
                            ></v-text-field>

                        </v-col>
                        <v-col cols="4" class="white--text subtitle-2 pt-9">
                            <v-select
                                    dense
                                    dark
                                    @change="onChangeOrientation"
                                    v-model="playlist.orientation"
                                    :items="orientList"
                                    item-text="title"
                                    item-value="key"
                                    v-if="!isGlobal"
                                    label="Ausrichtung"
                            >
                            </v-select>
                        </v-col>
                        <v-col cols="2" class="white--text subtitle-2">
                            Einträge: <span class="font-weight-bold">{{listData.cnt}}</span>
                        </v-col>
                        <v-col cols="2" class="white--text subtitle-2">
                            Länge: <span class="font-weight-bold">{{fancyTimeFormat(listData.duration)}}</span><br>
                        </v-col>
                        <v-col cols="2" class="white--text subtitle-2">
                            Gesamtgröße: <span class="font-weight-bold"> {{toMB(listData.size)}}</span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <input style="position: absolute; height: 10px; left: -1000px;"
                   type="file" name="files[]"
                   ref="iUpload"
                   title='Click to add Files'>
            <v-toolbar color="red accent-4" v-if="false">

                <!--
                <v-toolbar-title><v-breadcrumbs :items="crump" divider=">"></v-breadcrumbs></v-toolbar-title>
                -->

                <v-text-field
                        class="mt-7"
                        dense
                        solo
                        v-model="playlist.name"
                ></v-text-field>
                <v-toolbar-title class="white--text subtitle-2">
                    <span class="font-weight-bold">
                    <v-checkbox dark class="pt-6 pl-4" v-model="playlist.channel" label="Kanal" @change="onChangeChannel"></v-checkbox>
                    </span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text subtitle-2 pt-4">
                <v-select
                        dense
                        dark
                        @change="onChangeOrientation"
                        v-model="playlist.orientation"
                        :items="orientList"
                        item-text="title"
                        item-value="key"
                        label="Ausrichtung"
                >
                </v-select>
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text subtitle-2">
                    Einträge: <span class="font-weight-bold">{{listData.cnt}}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text subtitle-2">
                    Länge: <span class="font-weight-bold">{{fancyTimeFormat(listData.duration)}}</span><br>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text subtitle-2">
                    Gesamtgröße: <span class="font-weight-bold"> {{toMB(listData.size)}}</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="close" icon color="white">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <!-- <v-row justify="start">
                 <v-breadcrumbs :items="crump" divider=">"></v-breadcrumbs>
             </v-row>
             <v-row>
                 <v-col cols="10" xs="12">
                     <v-row>
                         <v-col cols="6" class="py-0 pl-6">
                             <v-text-field
                                     label="Playlist"
                                     clearable
                                     dense
                                     outlined
                                     v-model="playlist.name"
                             ></v-text-field>
                         </v-col>
                     </v-row>
                 </v-col>
                 <v-col cols="2" xs="12" style="text-align: right">
                     <v-btn @click="close" icon color="red">
                         <v-icon>close</v-icon>
                     </v-btn>
                 </v-col>
             </v-row> -->
            <v-responsive
                    class="overflow-y-auto"
                    max-height="78vh"
            >
                <TablePlayListItems ref="table" :play-list-guid="guid" class="pa-4" @getCount="getCount"
                                    @startUpload="startUpload"></TablePlayListItems>
            </v-responsive>
            <v-footer absolute color="white">
                <v-btn @click="cancelItem()" small color="grey" class="text-none" outlined>Abbrechen</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="updateItem()" small color="green" class="text-none" outlined elevation="3">Speichern
                </v-btn>
            </v-footer>
            <!-- <v-row>
                 <v-col cols="6" class="py-0">
                     <v-btn @click="cancelItem()" small color="grey" class="text-none" outlined>Abbrechen</v-btn>
                 </v-col>
                 <v-col cols="6" class="py-0 text-right">
                     <v-btn @click="updateItem()" small color="green" class="text-none" outlined elevation="3">Speichern
                     </v-btn>
                 </v-col>


             </v-row> -->
        </v-card>
    </v-container>
</template>

<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import TablePlayListItems from "../../tables/TablePlaylistItems"

    export default {
        name: 'PlaylistDefault',
        components: {TablePlayListItems},
        data() {
            return {
                listData: {
                    cnt: -1,
                    size: -1,
                    duration: -1
                },
                orientList: [
                    {
                        key: 'vertical',
                        title: 'Vertikal'
                    },
                    {
                        key: 'horizontal',
                        title: 'Horizontal'
                    }
                ],
                items: [],
                isGlobal: false,
                playlist: {
                    name: ''
                },
                crump: [{
                    text: 'Dashboard',
                    disabled: false,
                    href: '/#/Dashboard/Netzwerke',
                }],
                guid: '-1',
                progress: 100,
                uploadConfig: {
                    uploadUrl: '',
                    jQueryDivName: '#uploadCenter'
                }
            }
        },
        methods: {
            canUploadUnlimitedVideos: function () {
                const credentials = Vue.prototype.$api.getCredentials()
                const user = credentials && credentials.data ? credentials.data : {}
                const role = String(user.role || user.roleName || '').trim().toLowerCase()
                return role === 'admin' || role === 'administrator'
            },
            toMB: function (bytes, decimals) {
                if (bytes == 0) return '0 Bytes';
                var k = 1024,
                    dm = decimals <= 0 ? 0 : decimals || 2,
                    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            fancyTimeFormat: function (time) {

                var d = function display (seconds) {
                    const format = val => `0${Math.floor(val)}`.slice(-2)
                    const hours = seconds / 3600
                    const minutes = (seconds % 3600) / 60

                    return [hours, minutes, seconds % 60].map(format).join(':')
                }
                return d(time)
            },
            toMinutes: function (duration) {
                var result = duration / 60
                result = result.toFixed(2)
                return result
            },
            startUpload: function () {
                console.log('startUpload')
                this.$refs.iUpload.click()
            },
            getCount: function (data) {
                console.log('getCount', data)
                this.listData = data
            },
            onGetData: function (data) {
                console.log('playlist', data)
                this.playlist = data
                this.$refs.table.reload(this.guid)
                this.isGlobal = this.playlist.guid === 'GlobalMediathekH' || this.playlist.guid ==='GlobalMediathekV'
            },
            onGetItems: function (data) {
                console.log('onGetItems', data)
                this.items = data
            },
            onUploadProgress: function (id, percent) {
                console.log(id, percent)
                Vue.prototype.$eventHub.$emit('OnProgress', percent)
                this.progress = percent
            },
            onUploadSuccess(id, data) {
                console.log('upload done', id, data)
                this.$refs.table.reload(this.guid)
                Vue.prototype.$eventHub.$emit('OnUploadSuccess')
            },
            getUploadErrorMessage: function (message, xhr) {
                let uploadErrorMessage = typeof message === 'string' && message.trim()
                    ? message
                    : ''
                let response = xhr && xhr.responseJSON

                if (!response && xhr && xhr.responseText) {
                    try {
                        response = JSON.parse(xhr.responseText)
                    } catch (_error) {
                        response = xhr.responseText
                    }
                }

                if (response && typeof response === 'object') {
                    uploadErrorMessage = response.message || response.error || uploadErrorMessage
                } else if (typeof response === 'string' && response.trim()) {
                    uploadErrorMessage = response
                }

                return uploadErrorMessage || 'Der Server konnte die Datei nicht verarbeiten.'
            },
            close: function () {
                window.history.back();
            },
            cancelItem: function () {
                this.$router.push('/Dashboard/Playlist')
                Vue.prototype.$eventHub.$emit('OnProgress', 100)
            },
            updateItem: function () {
                Vue.prototype.$api.updatePlayList(this.playlist.guid, this.playlist, this.onItemUpdated)
            },
            onChangeChannel: function () {
                console.log('onChange', this.playlist)
                this.updateItem()
            },
            onChangeOrientation: function () {
                console.log('onChangeOrientation', this.playlist)
                this.updateItem()
            },
            initDragAndDrop(config, eventHub) {
                console.log('init drag and drop', config)
                config.eventHub = eventHub
                var cmp = this
                window.jQuery(config.jQueryDivName).dmUploader({
                    url: function () {
                        return config.uploadUrl
                    },
                    fileName: 'files',
                    dataType: 'json',
                    headers: {},
                    allowedTypes: '*',
                    extFilter: 'jpg;jpeg;png;webp;heic;mp4;mov;m4v',
                    // The server remains authoritative. This only prevents the
                    // legacy uploader from rejecting an administrator's video
                    // before it can reach the server-side role check.
                    maxFileSize: cmp.canUploadUnlimitedVideos() ? Infinity : 100 * 1024 * 1024,
                    onInit: function () {
                        console.log('onInit uploader')
                    },
                    onBeforeUpload: function (id) {
                        // updateFileStatus(id, 'uploading', 'Uploading...')
                        console.log(id)
                        config.eventHub.$emit('OnProgress', 0)
                        config.eventHub.$emit('lockScreen')
                    },
                    onNewFile: function (id, file) {
                        config.eventHub.$emit('unlockScreen')
                        console.log(id, file)
                    },
                    onComplete: function () {
                        console.log('upload complete')
                        config.eventHub.$emit('unlockScreen')
                    },
                    onUploadProgress: function (id, percent) {
                        if (config.onUploadProgress) config.onUploadProgress(id, percent)
                    },
                    onUploadSuccess: function (id, data) {
                        if (config.onUploadSuccess) config.onUploadSuccess(id, data)
                        cmp.$eventHub.$emit('unlockScreen')
                    },
                    onUploadError: function (id, message, xhr) {
                        const uploadErrorMessage = cmp.getUploadErrorMessage(message, xhr)
                        cmp.$eventHub.$emit('unlockScreen')
                        // The application-wide upload feedback is intentionally used here.
                        // Calling SweetAlert with the legacy positional API crashes with
                        // SweetAlert2 when the server response has no message.
                        cmp.$eventHub.$emit('OnUploadError', uploadErrorMessage)
                    },
                    onFileTypeError: function () {
                        cmp.$eventHub.$emit('OnUploadError', 'Dieses Format wird nicht unterstützt. Erlaubt sind JPG, PNG, WebP, HEIC, MP4, MOV und M4V.')
                    },
                    onFileSizeError: function () {
                        cmp.$eventHub.$emit('OnUploadError', 'Die Datei ist zu groß. Videos dürfen maximal 100 MB groß sein; Bilder maximal 10 MB. Administratoren dürfen größere Videos hochladen.')
                    },
                    onFileExtError: function () {
                        cmp.$eventHub.$emit('OnUploadError', 'Dieses Format wird nicht unterstützt. Erlaubt sind JPG, PNG, WebP, HEIC, MP4, MOV und M4V.')
                    },
                    onFallbackMode: function (message) {
                        swal(
                            'Upload Fehler',
                            'Browser not supported(do something else here!): ' + message,
                            'error'
                        )
                    }
                })
            }
        },
        mounted() {
            this.guid = this.$route.params.guid
            Vue.prototype.$api.loadPlayList(this.guid, this.onGetData)
            this.uploadConfig.uploadUrl = Vue.prototype.$config.HOST + '/v1/playlists/upload/' + this.guid
            this.uploadConfig.onUploadProgress = this.onUploadProgress
            this.uploadConfig.onUploadSuccess = this.onUploadSuccess
            this.initDragAndDrop(this.uploadConfig, Vue.prototype.$eventHub)
            if (this.$route.params.companyId) {
                this.crump.push({
                    text: 'Unternehmen',
                    href: '/#/Netzwerke/' + this.$route.params.companyId
                })
            }
        }
    }
</script>

<style scoped>.verySmallTF {
    font-size: 10px;
    line-height: 10px;
}
.verySmallTF .v-input__slot {
    padding: 0px;
    font-size: 10px;
}
.verySmallTF .v-input__control {
    padding: 0px;
    font-size: 10px;
    line-height: 10px;
}


</style>
